import { Expose, Type } from '@nts/std/serialization';
import { MetaDataDescriptions } from './meta-data-descriptions';
import { UserMetaData } from './user-meta-data';

export abstract class CoreMetaData {

    constructor(
        name?: string,
        descriptions?: MetaDataDescriptions,
        userMetaData?: UserMetaData,
    ) {
        this.name = name;
        this.descriptions = descriptions ?? new MetaDataDescriptions();
        this.userMetaData = userMetaData;
    }

    context?: any;

    /**
     * Property name in Pascal Case
     */
    @Expose()
    name: string;

    @Expose()
    @Type(() => MetaDataDescriptions)
    descriptions: MetaDataDescriptions;

    /**
     * MetaDati che dipendono dall'utente corrente
     */
    @Expose()
    @Type(() => UserMetaData)
    userMetaData?: UserMetaData;

    set(data: any) {
        if (data?.name != null) {
            this.name = data.name;
        }
        if (data?.userMetaData != null) {
            this.userMetaData = data.userMetaData;
        }        
    }
}
